module.exports = __webpack_public_path__ + "img/qsgy.6fd57c33.png";